import {
	GET_CATEGORIES_SUCCESS,
	GET_CATEGORIES_FAILED,
	CREATE_CATEGORY_SUCCESS,
	CREATE_CATEGORY_FAILED,
	UPDATE_CATEGORY_SUCCESS,
	UPDATE_CATEGORY_FAILED,
	DELETE_CATEGORY_SUCCESS,
	DELETE_CATEGORY_FAILED
} from '../actions/index';

const initialState = {
	categories: null,
	loading: true,
	error: null,
};

const categoryReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_CATEGORIES_SUCCESS:
			return {
				...state,
				categories: action.payload,
				loading: false,
			};
		case CREATE_CATEGORY_SUCCESS:
			console.log([...state.categories,action.payload]);
			return {
				...state,
				categories: state.categories
					? [...state.categories, action.payload]
					: [action.payload],
				loading: false,
			};
		case UPDATE_CATEGORY_SUCCESS:
			return {
				...state,
				categories: state.categories.map((category) =>
					category.category_id === action.payload.category_id
						? action.payload
						: category
				),
				loading: false,
			};
		case DELETE_CATEGORY_SUCCESS:
			console.log(action.payload)
			return {
				...state,
				categories: state.categories.filter((category) =>
					category.category_id != action.payload.category_id
				),
				loading: false,
			};
		case GET_CATEGORIES_FAILED:
		case CREATE_CATEGORY_FAILED:
		case UPDATE_CATEGORY_FAILED:
		case DELETE_CATEGORY_FAILED:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export default categoryReducer;
